/* eslint-disable import/prefer-default-export */

import { Program } from "types";

declare global {
  interface Window {
    dataLayer: any[];
  }
}
type PurchaseEventData = {
  price?: number;
  currency?: string;
  credits: number;
  type: string;
  id?: string;
  name?: string;
};
// get gclid from localStorage
export const getGclid = () => {
  const adInfo = localStorage.getItem("adInfo") || "";
  // adInfo is a string like "gclid 1234567890abcdefghijklmnopqrstuvwxyz123456"
  // get the value after gclid
  const gclidPattern = /\bgclid\s(.+?)\b/;
  const match = adInfo.match(gclidPattern);
  return match ? match[1] : "";
};

// get ref from localStorage
export const getRef = () => {
  return localStorage.getItem("ref") || "";
};

// Tracking new user registration
export const trackNewUserRegistration = (email = "unknown") => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "user_registration",
    GCLID: getGclid(),
    ref: getRef(),
    by_user: email,
  });
};

// Tracking new user registration with credit card
export const trackNewUserRegistrationWithCreditCard = (email = "unknown") => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "user_registration_with_credit_card",
    GCLID: getGclid(),
    ref: getRef(),
    by_user: email,
  });
};

// Tracking purchase credits for Google Ads conversion
export const trackPurchaseCredits = (
  program: Program | PurchaseEventData,
  email = "unknown"
) => {
  const { id, name, price, type, currency, credits } = program;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: "purchase_credits",
    ecommerce: {
      transaction_id: new Date().getTime(),
      value: price,
      currency,
      items: [
        {
          item_id: id,
          item_name: name,
          price,
          quantity: 1,
          item_category: type,
          credits,
        },
      ],
    },
    credit_type: type,
    price,
    currency,
    credit_amount: credits,
    purchase_date: new Date().toISOString(),
    GCLID: getGclid(),
    ref: getRef(),
    by_user: email,
  });
};

// Tracking trial user cancel subscription
export const trackTrialUserCancelSubscription = (email = "unknown") => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "trial_user_cancel_subscription",
    GCLID: getGclid(),
    ref: getRef(),
    by_user: email,
  });
};

// Measure ecommerce in Google Analytics 4
// Tracking add to cart event
export const trackAddToCartEvent = (email = "unknown") => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "add_to_cart",
    GCLID: getGclid(),
    ref: getRef(),
    by_user: email,
  });
};
// Tracking begin checkout event
export const trackBeginCheckoutEvent = (
  program: Program,
  email = "unknown"
) => {
  const { id, name, price, type, currency, credits } = program;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: "begin_checkout",
    ecommerce: {
      currency,
      value: price,
      items: [
        {
          item_id: id,
          item_name: name,
          price,
          quantity: 1,
          item_category: type,
          credits,
        },
      ],
    },
    GCLID: getGclid(),
    ref: getRef(),
    by_user: email,
  });
};

// Tracking add payment info event
export const trackAddPaymentInfo = (program: Program, email = "unknown") => {
  const { id, name, price, type, currency, credits } = program;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: "add_payment_info",
    ecommerce: {
      currency,
      value: price,
      items: [
        {
          item_id: id,
          item_name: name,
          price,
          quantity: 1,
          item_category: type,
          credits,
        },
      ],
    },
    GCLID: getGclid(),
    by_user: email,
  });
};

// Tracking purchase event for program
export const trackPurchaseEvent = (
  program: Program | PurchaseEventData,
  email = "unknown"
) => {
  const { id, name, price, type, currency, credits } = program;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: "purchase",
    ecommerce: {
      transaction_id: new Date().getTime(),
      value: price,
      currency,
      items: [
        {
          item_id: id,
          item_name: name,
          price,
          quantity: 1,
          item_category: type,
          credits,
        },
      ],
      credits,
    },
    GCLID: getGclid(),
    ref: getRef(),
    by_user: email,
  });
};
export const trackPurchase = (
  program: Program | PurchaseEventData,
  email = "unknown"
) => {
  // Track purchase credits succesfully to Google Ads Conversion
  trackPurchaseCredits(program, email);

  // Trach purchase event to have Google Analytics ecommerce report
  trackPurchaseEvent(program, email);
};
